import Image from "components/Image"
import ImageHeading from "components/ImageHeading"
import richText from "utilities/richText"

export default function IconsAndContent({ blok }) {
  return (
    <section className="overlap-header pb-8 lg:pb-0 bg-warm-white lg:bg-opacity-0">
      <div className="container-inset gap-8">
        <div className="relative flex text-blue flex-col lg:flex-row lg:rounded-4xl lg:shadow-icon-card lg:bg-white p-6 lg:p-10 items-left gap-8 z-20">
          <div className="mx-auto lg:w-1/3 xl:w-1/2">
            <ImageHeading headingImage={blok.heading_image} fallback={blok.heading} />
            <div className="prose">{richText(blok.content)}</div>
          </div>
          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 max-w-2xl mx-auto text-center items-center justify-items-center gap-10">
            {blok.icons.map((item) => (
              <div key={item._uid} className="flex flex-col items-center">
                <div className="relative">
                  <Image
                    unoptimized
                    width={95}
                    height={95}
                    src={item.icon.filename}
                    alt={item.icon.alt || item.label}
                    className="w-[95px] h-[95px]"
                  />
                </div>
                <div className="xl:text-xs">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
